module.exports = __webpack_public_path__ + "static/media/vcs.2038096e.svg";